import {
    ComponentFactory,
    ComponentFactoryResolver,
    ComponentRef,
    Injectable,
    ViewContainerRef
} from '@angular/core';
import {
    TooltipComponent,
    TooltipData
} from '../components/tooltip/tooltip.component';

declare let window: any;

@Injectable()
export class TooltipService {
    appViewContainerRef: ViewContainerRef;

    constructor(private _componentFactoryResolver: ComponentFactoryResolver) {}

    init(appViewContainerRef: ViewContainerRef) {
        this.appViewContainerRef = appViewContainerRef;
    }

    showTooltip(tooltipData: TooltipData, targetElement: any): ComponentRef < TooltipComponent > {
        let componentRef: ComponentRef < any > = this.createTooltip(tooltipData, targetElement);
        componentRef.instance.show();

        return componentRef;
    }

    createTooltip(tooltipData: TooltipData, targetElement: any): ComponentRef < TooltipComponent > {
        let componentFactory: ComponentFactory < any > = this._componentFactoryResolver.resolveComponentFactory(TooltipComponent);
        let componentRef: ComponentRef < any > = this.appViewContainerRef.createComponent(componentFactory, 0);
        document.querySelector("body").appendChild(componentRef.location.nativeElement); // muevo el elemento al body
        componentRef.instance.init(tooltipData, targetElement, componentRef);

        return componentRef;
    }

    toggleVisibility(tooltip: ComponentRef < TooltipComponent > ): ComponentRef < TooltipComponent > {
        if (tooltip.instance.visible) {
            tooltip.instance.hide();

        } else {
            tooltip = this.showTooltip(tooltip.instance.tooltipData, tooltip.instance.targetElement);
        }

        return tooltip;
    }
}